
import { i18nManager } from "../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import Notifications from "../../../shared/Notifications";
import { NotificationGroup } from "../../../shared/Notifiier";
import { ApiResponseData, BaseService, TournamentService, INotification, ITournamentEditionRegistered, MemberNotificationService, SanitizedResponse, TeamService, ITournamentEditionRegisteredParticipant } from "../../../../services";
import { ConfirmDialog, Siren } from "../../../shared/ConfirmDialog";
import { AlertInterface, useSubscription } from "@rivtn/noseur";

export interface YourTourActivitiesProps {
    registeredTournamentParticipant: ITournamentEditionRegisteredParticipant;
}

function YourTourActivities(props: YourTourActivitiesProps) {

    const { registeredTournamentParticipant } = props;
    const tournamentService = TournamentService.getInstance();
    const [searchParams, _] = ReactRouterDom.useSearchParams(window.location.search);

    return (<Notifications
        listStyle={{
            margin: "0px 15px 15px",
        }}
        style={{
            borderRadius: 10,
            paddingBottom: 10,
            margin: "0px 5px 5px",
            boxShadow: "0px 4px 14.3px rgba(0, 0, 0, 0.1)"
        }}
        fetch={(_, done, success) => {
            // TODO fetch the tournament notifs
            tournamentService.queryNotifications({
                participant_can_view: true,
                page: parseInt(searchParams.get("page") ?? "1"),
                size: parseInt(searchParams.get("size") ?? "50"),
                "tournament_edition.external_id": registeredTournamentParticipant.tournament_edition_registered.tournament_edition.external_id,
            }).then(({ sanitized, apiResponse }: SanitizedResponse<ApiResponseData<INotification> & { grouped_notifications: NotificationGroup }>) => {
                success(sanitized, apiResponse.secondary_data?.un_reads?.tournament_notifications);
            }).catch(BaseService.reportError).finally(done);
        }}
    />);

}

export default YourTourActivities;
